import { useEffect, useMemo, useState } from 'react';
import ReactDOM from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { frontendOptions, treatmentStatusesOptions } from "../../../../lib/systemData";
import { caseActions } from "../../../../store/case";
import CustomSelect from "../../../common/interactive/CustomSelect";
import { caseQuickUpdate } from "../../../../lib/fetchApi";
import { notificationActions } from "../../../../store/notifications";
import { formatDate } from "../../../../lib/script";
import Backdrop from "../../../common/modal/Backdrop";
import Modal from "../../../common/Modal";
import ModalInnerWrapper from "../../../common/ModalInnerWrapper";
import PannelBody from "../../../fragments/PannelBody";
import Button from "../../../common/Button";
import { filterActions } from "../../../../store/filter";
import InputBox from "../../../common/interactive/InputBox";
import BodySimpleModalV3 from "../../../common/modal/BodySimpleModalV3";
import { getCaseIdFromCasePayload } from "../../../../lib/caseUpdateHelpers";

/** Work-queue row edits skip Redux case slice unless the loaded activeCase is the same case (e.g. drawer open). */
function shouldMergeQuickUpdateIntoActiveCase(inWorkQ, activeCase) {
    if (!inWorkQ) return true
    if (!inWorkQ.case?.id || !activeCase) return false
    const storeId = getCaseIdFromCasePayload(activeCase)
    if (storeId == null) return false
    return Number(storeId) === Number(inWorkQ.case.id)
}

export default function StatusItemSelect({preSelectedValue, prefix, inWorkQ, aicaData}) {
    const dispatch = useDispatch()

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase) 

    const [modalopened, setModalopened] = useState(false)
    const [holdReasonModalopened, setHoldReasonModalopened] = useState(false)
    const [loading, setLoading] = useState(false)
    const [holdStatusData, setHoldStatusData] = useState(null)

    const updateHandler = async (data) => {  
        let reqBody = {
            type: data.identifier.type,
            type_id: data.identifier.type_id,
            fields: {
                [data.identifier.field] : data.data.value,
            }
        }   
        
        if (data.data.value == 7) { // if "Closed" (id === 7) is selected, need to show a modal
            setModalopened(data)
        } else if (data.data.value == 2) { // if "Hold" (id === 2) is selected, need to show a modal
            setHoldReasonModalopened(data)
            setHoldStatusData(data)
        } else {
            let extraIdentifier = {type: 'case_aica_department_status', field: prefix + '_updated_at', type_id: null, folder: 'aica_department_status'}
            // Use the user's LOCAL calendar day so the saved value matches what they see.
            let today = formatDate(new Date())
            let dispatchObj = {
                folder: data.identifier.folder,
                item: {
                    fields: [
                        {
                            field: data.identifier.field,
                            value: data.data.value
                        },
                        {
                            field: extraIdentifier.field,
                            value: today
                        }
                    ]            
                }
            }
            if (inWorkQ) {
                let dispatchObjInWorkQ = {
                    case_id: inWorkQ.case.id,
                    folder: data.identifier.folder,
                    item: {
                        fields: [
                            {
                                field: data.identifier.field,
                                value: data.data.value
                            }
                        ],
                        // complexFields: [
                        //     {
                        //         prop: data.identifier.field,
                        //         fields: [
                        //             {
                        //                 field: 'status',
                        //                 value: data.data.value
                        //             }
                        //         ]
                        //     }
                        // ]          
                    }
                }
                dispatch(filterActions.updateItemInWorkQRow(dispatchObjInWorkQ))
                if (shouldMergeQuickUpdateIntoActiveCase(inWorkQ, activeCase)) {
                    dispatch(caseActions.modifyActiveCaseMultipleObject(dispatchObj))
                }
            } else { 
                dispatch(caseActions.modifyActiveCaseMultipleObject(dispatchObj))  
            }

            const quickUpdateDispatch = shouldMergeQuickUpdateIntoActiveCase(inWorkQ, activeCase) ? dispatch : null
            let update = await caseQuickUpdate(userToken, inWorkQ ? inWorkQ.case.id : activeCase.case.id, reqBody, quickUpdateDispatch, !!inWorkQ)

            if (update && update.errorMessage) {
                dispatch(notificationActions.setError(update))
            } else {                
            } 
            
        }      
                
        
    }

    const [closedReason, setClosedReason] = useState(null)

    function  openModalHandler() {
        setModalopened(false)
        setClosedReason(null)
    }

    function openHoldReasonModalHandler() {
        setHoldReasonModalopened(true)
    }

    function closeHoldReasonModalHandler() {
        setHoldReasonModalopened(false)
        setHoldStatusData(null)
    }

    async function setCloseReason(event) {
        event.preventDefault()
        setLoading(true)
        try {
            const fd = new FormData(event.target)

            const formData = Object.fromEntries(fd.entries())

            let reqBody = {
                type: modalopened.identifier.type,
                type_id: modalopened.identifier.type_id,
                fields: {
                    [modalopened.identifier.field] : modalopened.data.value,
                    [prefix + '_closed_reason']: formData.closed_reason
                }
            }  

            let extraIdentifier = {type: 'case_aica_department_status', field: prefix + '_updated_at', type_id: null, folder: 'aica_department_status'}
            let today = formatDate(new Date())
            let dispatchObj = {
                case_id: inWorkQ ? inWorkQ.case.id : activeCase.case.id,
                folder: modalopened.identifier.folder,
                item: {
                    fields: [
                        {
                            field: modalopened.identifier.field,
                            value: modalopened.data.value
                        },
                        {
                            field: extraIdentifier.field,
                            value: today
                        },
                        {
                            field: prefix + '_closed_reason',
                            value: formData.closed_reason
                        }
                    ]            
                }
            }

            if (inWorkQ) {
                dispatch(filterActions.updateItemInWorkQRow(dispatchObj))
                if (shouldMergeQuickUpdateIntoActiveCase(inWorkQ, activeCase)) {
                    dispatch(caseActions.modifyActiveCaseMultipleObject(dispatchObj))
                }
            } else { 
                dispatch(caseActions.modifyActiveCaseMultipleObject(dispatchObj))  
            }
              

            const quickUpdateDispatch = shouldMergeQuickUpdateIntoActiveCase(inWorkQ, activeCase) ? dispatch : null
            let update = await caseQuickUpdate(userToken, inWorkQ ? inWorkQ.case.id : activeCase.case.id, reqBody, quickUpdateDispatch, !!inWorkQ)

            if (update && update.errorMessage) {
                dispatch(notificationActions.setError(update))
            } else {                

                openModalHandler()
            } 
        } finally {
            setLoading(false)
        }
    }

    function changeReasonHandler(value) {
        setClosedReason(value.data.value)
    }


    const [holdDays, setHoldDays] = useState(null)
    const [holdReasonText, setHoldReasonText] = useState(null)

    function changeHoldDaysHandler(value) {
        setHoldDays(value.data.value)
    }
    function changeHoldReasonHandler(value) {
        setHoldReasonText(value.data.value)
    }

    async function setHoldReason(event) {
        event.preventDefault()
        setLoading(true)
        try {
            const fd = new FormData(event.target)

            const formData = Object.fromEntries(fd.entries())

            let reqBody = {
                type: 'case_aica_department_status',
                type_id: null,
                fields: {
                    ...formData,
                    [holdStatusData.identifier.field] : holdStatusData.data.value,
                }
            }  
            let today = formatDate(new Date())

            let dispatchObj = {
                case_id: inWorkQ ? inWorkQ.case.id : activeCase.case.id,
                folder: holdStatusData.identifier.folder,
                item: {
                    fields: [
                        {
                            field: holdStatusData.identifier.field,
                            value: holdStatusData.data.value
                        },
                        {
                            field: prefix + '_hold_reason',
                            value: formData[prefix + '_hold_reason']
                        },
                        {
                            field: prefix + '_hold_days',
                            value: formData[prefix + '_hold_days']
                        },
                        {
                            field: prefix + '_updated_at',
                            value: today
                        }
                    ]            
                }
            }


            if (inWorkQ) {
                dispatch(filterActions.updateItemInWorkQRow(dispatchObj))
                if (shouldMergeQuickUpdateIntoActiveCase(inWorkQ, activeCase)) {
                    dispatch(caseActions.modifyActiveCaseMultipleObject(dispatchObj))
                }
            } else { 
                dispatch(caseActions.modifyActiveCaseMultipleObject(dispatchObj))  
            }
              

            const quickUpdateDispatch = shouldMergeQuickUpdateIntoActiveCase(inWorkQ, activeCase) ? dispatch : null
            let update = await caseQuickUpdate(userToken, inWorkQ ? inWorkQ.case.id : activeCase.case.id, reqBody, quickUpdateDispatch, !!inWorkQ)

            if (update && update.errorMessage) {
                dispatch(notificationActions.setError(update))
            } else {                

                closeHoldReasonModalHandler()
            } 
        } finally {
            setLoading(false)
        }
    }

    

    const [message, setMessage] = useState(null);
    const treatmentStatusOptionsData = useMemo(() => treatmentStatusesOptions(), [])

    useEffect(() => {
        let msg = null;
        if (aicaData && aicaData[prefix + '_status'] == 2 && aicaData[prefix + '_hold_reason']) {
            msg = <div>Hold reason: {aicaData[prefix + '_hold_reason']} for {aicaData[prefix + '_hold_days']} days</div>;
        }
        if (aicaData && aicaData[prefix + '_status'] == 7 && aicaData[prefix + '_closed_reason']) {
            msg = <div>Closed reason: {aicaData[prefix + '_closed_reason']}</div>;
        }
        setMessage(msg);
    }, [aicaData, prefix]);



    return <>

        <BodySimpleModalV3 message={message} disabled={!message}>
            <CustomSelect fixedDrawer={true} minWidth={100} action={updateHandler} preSelectedValue={preSelectedValue} optionsData={treatmentStatusOptionsData} thin_select={true} undetermined={!preSelectedValue ? 'N/A' : null} identifier={{type: 'case_aica_department_status', field: prefix + '_status', type_id: null, folder: 'aica_department_status', prefix: prefix}}/>

        </BodySimpleModalV3>
        
        {modalopened && <>
            {ReactDOM.createPortal(
                <Backdrop hide={openModalHandler} />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper closeModal={openModalHandler} modalTitle={'Close status reason'}>                        
                        <PannelBody>
                            <form onSubmit={setCloseReason}>
                                <div className="row">
                                    <CustomSelect label={'Reason'} name={'closed_reason'} optionsData={frontendOptions()?.DEPARTMENT_CLOSED_REASONS} action={changeReasonHandler} preSelectedValue={closedReason}/>
                                </div>
                                <div className="row">    
                                    <div className='flex-container-equal m-top-24'>
                                        <Button btnStyle={'btn_danger'} type={'submit'} isLoading={loading} isDisabled={!closedReason}><i className="ti ti-trash"></i>Set Status</Button>
                                        <Button click={openModalHandler} type={'button'}>Cancel</Button>
                                    </div>     
                                </div>     
                            </form>                    
                        </PannelBody>
                    </ModalInnerWrapper>
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>}

        {holdReasonModalopened && <>
            {ReactDOM.createPortal(
                <Backdrop hide={closeHoldReasonModalHandler} />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper closeModal={closeHoldReasonModalHandler} modalTitle={'Hold status reason'}>                        
                        <PannelBody>
                            <form onSubmit={setHoldReason}>
                                <div className="row">
                                    <InputBox label={'Reason'} type={'text'} name={`${prefix + '_hold_reason'}`} defaultValue={holdReasonText} action={changeHoldReasonHandler}/>
                                </div>
                                <div className="row">
                                    <InputBox label={'Number of days in hold'} type={'text'} name={`${prefix + '_hold_days'}`} format={'number'} maxNumericValue={14} defaultValue={holdDays} action={changeHoldDaysHandler}/>
                                    <small>Max 14 days</small>
                                </div>
                                <div className="row">    
                                    <div className='flex-container-equal m-top-24'>
                                        <Button btnStyle={'btn_danger'} type={'submit'} isLoading={loading} isDisabled={!holdReasonText && !holdDays}><i className="ti ti-trash"></i>Set Status</Button>
                                        <Button click={closeHoldReasonModalHandler} type={'button'}>Cancel</Button>
                                    </div>     
                                </div>     
                            </form>                    
                        </PannelBody>
                    </ModalInnerWrapper>
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>}
    </>
}